import {call, put, takeEvery} from '@redux-saga/core/effects';
import accountApi from 'Agent/Accounts/api/accountApi';
import {
  AccountActionType,
  changeAccounts,
  deletePolicyInformationReport,
  getAccounts,
  getPolicyInformationReports,
} from 'Agent/Accounts/ducks/account';
import {Account} from 'Agent/Accounts/models/Account';
import {AsyncResult, fromResult, Loading, LoadingAdditional} from 'Core/models/Async';
import {Page} from 'Core/models/Page';
import * as E from 'fp-ts/lib/Either';
import {pipe} from 'fp-ts/lib/pipeable';
import {all, takeLatest} from 'redux-saga/effects';
import {mergeWithNextPage} from 'Shared/utilities/PageUtility';
import {prop} from 'Shared/utilities/prop';
import {getApiCallGenerator} from 'Shared/utilities/sagaApiGenerators';
import {changePolicyInformationReports} from '../ducks/account';

function* getAccountsFromApi(action: ReturnType<typeof getAccounts>) {
  const {page, encryptedIdentifier, isNewYork, agentNumbers, filter, sort} = action.payload;

  if (page) {
    yield put(changeAccounts(new LoadingAdditional(page)));
  } else {
    yield put(changeAccounts(new Loading(page)));
  }

  const result: AsyncResult<Page<Account>> = yield page
    ? call(mergeWithNextPage, {existingPage: page})
    : call(accountApi.getAccounts, agentNumbers.map(prop('value')), isNewYork, encryptedIdentifier, filter, sort);

  yield pipe(
    result,
    E.map(fromResult),
    E.fold(
      value => put(changeAccounts(value)),
      value => put(changeAccounts(value))
    )
  );
}

function* watchFetchAccounts() {
  yield takeLatest(AccountActionType.GET_ACCOUNTS, getAccountsFromApi);
}

function* getPolicyInformationReportsFromApi(action: ReturnType<typeof getPolicyInformationReports>) {
  const {encryptedIdentifier, userId} = action.payload;
  yield getApiCallGenerator(
    () => accountApi.getPolicyInformationReports(encryptedIdentifier, userId),
    changePolicyInformationReports
  )(action);
}
function* getPolicyInformationReportsSaga() {
  yield takeLatest(AccountActionType.GET_POLICY_INFORMATION_REPORTS, getPolicyInformationReportsFromApi);
}

function* deletePolicyInformationReportApi(action: ReturnType<typeof deletePolicyInformationReport>) {
  const {encryptedIdentifier, userId, reportId} = action.payload;
  yield call(accountApi.deletePolicyInformationReport, encryptedIdentifier, userId, reportId);

  yield put(getPolicyInformationReports(encryptedIdentifier, userId));
}

function* deletePolicyInformationReportSaga() {
  yield takeEvery(AccountActionType.REMOVE_POLICY_INFORMATION_REPORTS, deletePolicyInformationReportApi);
}
export default function*() {
  yield all([watchFetchAccounts(), getPolicyInformationReportsSaga(), deletePolicyInformationReportSaga()]);
}
